document.addEventListener("DOMContentLoaded", function () {
	const cabinCards = document.querySelectorAll(".hero__cabin-card");
	if (!cabinCards.length) return;

	cabinCards.forEach(function (card) {
		card.addEventListener("click", function () {
			// Remove selection from all cards
			cabinCards.forEach(function (c) {
				c.classList.remove("is-selected");
			});

			// Select this card
			card.classList.add("is-selected");

			// Update the hidden dataset inputs
			const hero = card.closest(".cruise.-hero");
			if (!hero) return;

			const dataset = hero.querySelector(".dataset");
			if (!dataset) return;

			const gradeInput = dataset.querySelector('input[name="grade"]');
			const priceInput = dataset.querySelector('input[name="price"]');

			if (gradeInput) {
				gradeInput.value = card.getAttribute("data-cabin-type") || "";
			}
			if (priceInput) {
				priceInput.value = card.getAttribute("data-cabin-price") || "";
			}
		});
	});
});
